import merge from 'deepmerge'
import DeliveryCrudRoutes from './DeliveryCrudRoutes'
import DeliveryRoutes from './DeliveryRoutes'
import DeliveryFlowRoutes from './DeliveryFlowRoutes'
import DeliveryStockRoutes from './DeliveryStockRoutes'
import DeliveryRoutesCore from './DeliveryRoutesCore'
import DeliverySurveyRoutes from './DeliverySurveyRoutes'

const routes = merge.all([DeliverySurveyRoutes, DeliveryRoutesCore, DeliveryCrudRoutes, DeliveryRoutes, DeliveryFlowRoutes, DeliveryStockRoutes])


export default routes;

